import './styles.scss';

import React, { useContext, useEffect, useState } from 'react';

import { Navigate } from 'react-router';

import styled from '@emotion/styled';

import { Container } from '../../components/Container';
import { VisibleOn } from '../../components/VisibleOn';
import { useFirebaseAuth, useRouter, useStoreData } from '../../hooks';
import { CoreContext } from '../../providers';
import { Storyblok, StoryblokSection } from '../../storyblok';
import { isEmptyObject } from '../../utils';
import { Confirmation } from './Confirmation';
import { Process } from './Process';

export const AltinnProcess = ({
    sectionData,
}: StoryblokSection<Storyblok.Component.AltinnProcess>) => {
    const { settings } = useContext(CoreContext);
    const [processStep, setProcessStep] = useState<'process' | 'confirmation'>(
        'process',
    );

    const { scoreData } = useStoreData().user;
    const { currentUser } = useFirebaseAuth();

    const { navigate } = useRouter();

    /**
     * Users who are logged-in and got scoreData should not be able to go
     * through "Altinn Login Flow" over again
     */
    useEffect(() => {
        if (currentUser && !isEmptyObject(scoreData)) {
            navigate(sectionData.redirectPathOnSuccess);
        }
    }, []);

    return (
        <Section>
            {sectionData.backgroundImage &&
                sectionData.backgroundImage.filename && (
                    <VisibleOn tablet desktop>
                        <BackgroundImage
                            src={sectionData.backgroundImage.filename}
                            alt="Background"
                        />
                    </VisibleOn>
                )}

            <StyledContainer>
                {processStep === 'process' && (
                    <Process setProcessStep={setProcessStep} {...sectionData} />
                )}

                {processStep === 'confirmation' &&
                    (settings.languageVersion === 'formue' ? (
                        <Navigate to="altinn/success" />
                    ) : (
                        <Confirmation sectionData={sectionData} />
                    ))}
            </StyledContainer>
        </Section>
    );
};

const Section = styled.section`
    position: relative;
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const StyledContainer = styled(Container)`
    max-width: 1600px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    text-align: center;
`;

const BackgroundImage = styled.img`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: left center;
    pointer-events: none;
`;
